__turbopack_context__.v({
  "captions": "captions-module__ybK-eG__captions",
});
